import React, { useState } from 'react';
import { DialogBox, DialogBoxBody, DialogBoxHeader, IconClose } from '@americanexpress/dls-react';
import { ButtonType } from 'src/types/button-type.enum';
import IconButton from 'src/components/icon-button/IconButton';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import styles from './infoModal.module.scss';
import LiteralsService from 'src/services/literals/LiteralsService';
import Selectors from 'src/utils/selectors';

interface InfoModalProps {
    anchorTitle: string;
    anchorTag: string;
    id: string;
    title: string;
    body: JSX.Element;
    onCloseClick: () => void;
}

export default function InfoModal({
    anchorTitle,
    anchorTag,
    id,
    title,
    body,
    onCloseClick
}: InfoModalProps): JSX.Element {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Anchor
                className={styles.anchor}
                tag={anchorTag}
                onClick={() => setOpen(!open)}
                data-cy={Selectors.SpendSmart.INFO_MODAL_OPEN}
            >
                {anchorTitle}
            </Anchor>
            {open && (
                <DialogBox id={id} className={styles.modal} data-cy={Selectors.SpendSmart.INFO_MODAL}>
                    <DialogBoxHeader id={`${id}-header`} title={title} />
                    <DialogBoxBody id={`${id}-body`} className={styles.body}>
                        <IconButton
                            icon={<IconClose />}
                            title={LiteralsService.getLiteral('InfoModal.close')}
                            className={styles.closeButton}
                            variant={ButtonType.PRIMARY_DARK}
                            onClick={() => {
                                setOpen(false);
                                onCloseClick?.();
                            }}
                            data-cy={Selectors.SpendSmart.INFO_MODAL_CLOSE}
                        />
                        <div className={styles.content} data-cy={Selectors.SpendSmart.INFO_MODAL_CONTENT}>
                            {body}
                        </div>
                    </DialogBoxBody>
                </DialogBox>
            )}
        </>
    );
}
